import React from "react";
import MulSelector from "../TeaSelector/MultipleSelector";
import { useIntl } from 'umi'

export default function GametypeAll(props: any) {
  const {
    onConfirm,
    value = [],
  } = props;

  const { formatMessage } = useIntl();

  const gameType = [
    {
      value: 'Mobile',
      text: formatMessage({ id: 'dbi-sm-filter-mobile' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-mobile' }),
    },
    {
      value: 'PC',
      text: formatMessage({ id: 'dbi-sm-filter-pc' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-pc' }),
    },
    {
      value: 'Console',
      text: formatMessage({ id: 'dbi-sm-filter-console' }),
      buttonText: formatMessage({ id: 'dbi-sm-filter-console' }),
    }
  ]

  const handleChange = (values: string[] | string) => {
    if (onConfirm instanceof Function) {
      onConfirm(values);
    }
  };

  return (
    <MulSelector
      value={typeof value === 'string' ? [] : value}
      options={gameType}
      buttonName={formatMessage({ id: 'dbi-sm-filter-gametype' })}
      onChange={handleChange}
    />
  )
}